import { PodcastWorkflowTemplate } from 'redux/middleware/api/podcast-service';
import { TemplateType } from 'types';
import bem from 'utils/bem';
import { hasHeadlinerReferrer } from 'utils/routes';

export const block = bem('template-wizard');

function isUST(template: PodcastWorkflowTemplate | undefined) {
  return template?.templateType === TemplateType.USER_GENERATED;
}

export function shouldSeeLandingPage(
  template: PodcastWorkflowTemplate | undefined,
) {
  return isUST(template) || !hasHeadlinerReferrer();
}

export function getTemplateFlowType(
  template: PodcastWorkflowTemplate | undefined,
) {
  if (isUST(template)) {
    return undefined;
  }

  return template?.sourceMediaType === 'video' ? 'video' : 'audio';
}

export function templateRequiresFlowSelection(
  template: PodcastWorkflowTemplate | undefined,
) {
  return isUST(template);
}
